import { render } from "./IconBold.vue?vue&type=template&id=4e716c14"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconBold.vue"]])

export default __exports__